import { isDefined } from "@omni/utils/helper.utils";
import { RefObject, useEffect, useRef } from "react";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { useWoosmapScript } from "@/services/woosmap/woosmap.initializer";
import { ScriptLoadingStates } from "@/utils/hooks/useScript.hook";

import { TooltipTemplate } from "../components/map/tooltip.template";
import { MARKER_OFFSET } from "../storeSearch.config";
import { findStoreUrl } from "../storeSearch.helpers";
import { StoreUrl } from "../storeSearch.types";
import { useMap } from "./useMap.hook";

const ceateInfoWindow = (onClose: () => void) => {
    const infoWindow = new woosmap.map.InfoWindow({});
    infoWindow.addListener("closeclick", onClose);

    return infoWindow;
};

export const useInfoWindow = (
    mapElementRef: RefObject<HTMLDivElement | null>,
    storeUrls: StoreUrl[],
    onCloseClick: () => void
) => {
    const { t } = useGranite();

    const woosmapScriptLoadingState = useWoosmapScript();
    const ready = woosmapScriptLoadingState === ScriptLoadingStates.Ready;

    const infoWindowRef = useRef<woosmap.map.InfoWindow | null>(null);

    const map = useMap(mapElementRef);

    const open = (storeGeoJSON: woosmap.map.stores.StoreResponse) => {
        if (!isDefined(map)) return;

        infoWindowRef.current?.setOffset(
            new woosmap.map.Point(0, MARKER_OFFSET)
        );

        infoWindowRef.current?.setContent(
            TooltipTemplate(
                t,
                storeGeoJSON.properties,
                findStoreUrl(
                    storeUrls,
                    storeGeoJSON.properties.user_properties.storeId
                )
            )
        );

        infoWindowRef.current?.open(map, {
            lat: storeGeoJSON.geometry.coordinates[1],
            lng: storeGeoJSON.geometry.coordinates[0]
        });
    };

    const close = () => {
        infoWindowRef.current?.close();
    };

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (!ready) return;
        if (isDefined(infoWindowRef.current)) return;

        infoWindowRef.current = ceateInfoWindow(onCloseClick);
    }, [ready]);

    return {
        open: open,
        close: close
    };
};
